<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">摄像头设备</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="equipmentName">
            <el-input 
              v-model="queryParams.equipmentName" 
              placeholder="请输入设备名称">
            </el-input>
          </el-form-item>

          <!-- <el-form-item label="区域" prop="areaCode">
            <treeselect
              v-model="queryParams.areaCode"
              :options="regionData"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item> -->
          <el-form-item label="是否在线" prop="sourceStatus">
            <el-select v-model="queryParams.sourceStatus" placeholder="请选择">
              <el-option v-for="item in dict2.type['video-sourceStatus']" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备类型" prop="deviceType">
            <el-select v-model="queryParams.deviceType" placeholder="请选择">
              <el-option v-for="item in dict2.type['video-device-type']" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="onAdd">新 增</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="monitorEquipmentList"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="name" label="设备名称"></el-table-column>
              <el-table-column prop="deviceType" label="设备类型">
                <template slot-scope="scope">
                  <DictTag :options="dict2.type['video-device-type']" :value="scope.row.deviceType" />
                </template>
              </el-table-column>
              <!-- <el-table-column  label="区域"></el-table-column> -->
              <el-table-column prop="longitude" label="经度"></el-table-column>
              <el-table-column prop="latitude" label="纬度"></el-table-column>
              <el-table-column prop="sourceStatus" label="设备状态">
                <template slot-scope="scope">
                  <DictTag :options="dict2.type['video-sourceStatus']" :value="scope.row.sourceStatus" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { videoList } from "@/api/src/videoApiGb";
import { listEquipmentAreaTree } from "@/api/src/equipmentArea";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "MonitorEquipmentViewNew",
  controller: "UI",
  action: "MonitorEquipmentViewNew",
  components: {
    Treeselect
  },
  dicts2:['video-device-type','video-sourceStatus'],
  data() {
    return {
      // 设备类型
      code: '',
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        equipmentName: '',
        sourceStatus: null,
        deviceType: null,
      },
      page: 1,
      size: 10,
      // 区域数据
      regionData: [],
      // 表格数据
      monitorEquipmentList: [],
    };
  },
  created: function() {
    this.$nextTick(()=>{
      this.getList()
      // this.getAreaTree()
    });
  },
  methods: {
    // 查询区域树
    getAreaTree(){
      listEquipmentAreaTree().then(response =>{
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.code,
            label: obj.label,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.regionData = response.data.map(obj => mapTree(obj));
      });
    },
    // 获取设备code
    init(){
      this.getList();
    },
    // 查询
    getList() {
      this.loading = true;
        let { queryParams, page, size} = this,data = {
        condition: queryParams,
        page,
        size
      }
      videoList(data).then(response =>{
        console.log(response,'000')
        this.monitorEquipmentList = response.data.records;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    // 点击查询按钮
    onSearch() {
      this.page = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.onSearch();
    },
    // 点击新增按钮
    onAdd() {
      this.$router.push({
        path: "/plugin/equipment/UI/MonitorEquipmentInfoNew",
        query: { areaTree: this.regionData, type: "add"},
      });
    },
    // 行查看
    queryDetail(row) {
      this.$router.push({
        path: "/plugin/equipment/ui/MonitorEquipmentInfoNew",
        query: { areaTree: this.regionData, rowData: JSON.stringify(row), type: "look" },
      });
    },
    // 行编辑
    editDetail(row) {
      this.$router.push({
        path: "/plugin/equipment/ui/MonitorEquipmentInfoNew",
        query: { areaTree: this.regionData, rowData: JSON.stringify(row), type: "edit" },
      });
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.page = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.page = val;
      this.getList();
    }
  },
};
</script>
<style scoped>
::v-deep .el-form-item{
  vertical-align: middle;
}
::v-deep .vue-treeselect__control{
  width: 178px;
  height: 4rem;
  border-radius: 0px !important;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__menu{
  border-radius: 0px;
}
</style>
